import { npcLogConstant } from 'src/redux/actions/constant';

const initialState = { response: null, isDeleteNpcEntry: false, loading: false };

export const deleteNpcEntryReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case npcLogConstant.DELETE_NPC_ENTRY_SUCCESS:
      return { ...state, isDeleteNpcEntry: true, response: action.payload, loading: false };
    case npcLogConstant.DELETE_NPC_ENTRY_FAILURE:
      return { ...state, isDeleteNpcEntry: false, response: action.payload, loading: false };
    case npcLogConstant.DELETE_NPC_ENTRY_LOADER:
      return { ...state, loading: true };
    case npcLogConstant.DELETE_NPC_ENTRY_RESET:
      return initialState;
    default:
      return state;
  }
};
